import { formatCell } from "utils/utils";

// Filter out null values from an object
function filterNullValues(obj) {
  if (obj == null || typeof obj !== 'object') return obj;
  const filtered = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && obj[key] != null) {
      filtered[key] = obj[key];
    }
  }
  return filtered;
}

function parseEligibilitySearch(obj) {
  const result = [];
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];

      if (value == null) {
        continue;
      }

      if (key === "procedure_code_groups") {
        result.push([{ title: key, groups: unravelMultiGroup(value) }]);
      } else if (value instanceof Array) {
        result.push([{ title: key, groups: unravelSingleGroup(value) }]);
      } else if (typeof value === 'object') {
        const filteredValue = filterNullValues(value);
        // Skip sections that have no data after filtering
        if (Object.keys(filteredValue).length === 0) {
          continue;
        }
        result.push([
          {
            title: key.split("_").join(" "),
            data: filteredValue,
            columns: generateColumns(filteredValue),
          },
        ]);
      }
    }
  }
  return result;
}

function unravelMultiGroup(obj) {
  const result = [];
  // Handle null/undefined input
  if (obj == null) {
    return result;
  }
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      // Skip null/undefined values
      if (value == null) {
        continue;
      }
      if (value instanceof Array) {
        // Skip empty arrays
        if (value.length === 0) {
          continue;
        }
        // Check if code is not covered
        let temp = value;
        for (const row in value) {
          if (value[row] == null) continue;
          for (const subitem in value[row]) {
            if (subitem !== "is_covered" && subitem !== "code") {
              if (value[row]["is_covered"] === false) {
                temp[row][subitem] = "N/A";
              }
            }
          }
        }
        result.push([
          {
            title: key.split("_").join(" "),
            data: temp,
            columns: generateColumnsFromArray(temp),
          },
        ]);
      } else {
        if (key === "procedure_code_group_name") {
          result.push([{ procedure_code_group_name: value }]);
        } else {
          result.push([key, unravelMultiGroup(value)]);
        }
      }
    }
  }
  return result;
}

function unravelSingleGroup(obj) {
  const result = [];
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      // Skip null/undefined values in arrays
      if (value == null) {
        continue;
      }
      // Filter out null values from array elements if they're objects
      const filteredValue = typeof value === 'object' && !Array.isArray(value)
        ? filterNullValues(value)
        : value;
      // Skip if object is empty after filtering
      if (typeof filteredValue === 'object' && !Array.isArray(filteredValue) && Object.keys(filteredValue).length === 0) {
        continue;
      }
      result.push([
        {
          title: key.split("_").join(" "),
          data: filteredValue,
          columns: generateColumns(filteredValue),
        },
      ]);
    }
  }
  return result;
}

function generateColumnsFromArray(arrayOfObjects) {
  const allKeys = new Set();

  // Collect all possible keys from all objects (skip null/undefined elements)
  arrayOfObjects.forEach((obj) => {
    if (obj == null || typeof obj !== 'object') return;
    Object.keys(obj).forEach((key) => {
      // Only add keys with non-null values
      if (obj[key] != null) {
        allKeys.add(key);
      }
    });
  });

  const result = [];
  allKeys.forEach((key) => {
    result.push({
      Header: key.split("_").join(" "),
      accessor: key,
      Cell: ({ value }) => formatCell(key, value),
    });
  });

  return result;
}

function generateColumns(obj) {
  const result = [];
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      // Skip null/undefined values - only create columns for fields with actual data
      if (value == null) {
        continue;
      }
      result.push({
        Header: key.split("_").join(" "),
        accessor: key,
        Cell: ({ value }) => formatCell(key, value),
      });
    }
  }
  return result;
}

export default parseEligibilitySearch;
